import styles from "./roadmap.module.css";

export default function RoadmapSection() {
  const roadmapItems = [
    {
      phase: "Phase 1",
      title: "Tournaments",
      description: "Launch competitive tournaments with real prize pools",
    },
    {
      phase: "Phase 2",
      title: "Streamer Sponsorships",
      description: "Partner with top gaming streamers and content creators",
    },
    {
      phase: "Phase 3",
      title: "Community Hub",
      description: "Earn XP, exclusive rewards, and premium benefits",
    },
    {
      phase: "Phase 4",
      title: "Pro Gear Marketplace",
      description: "Full e-commerce for gaming peripherals and collectibles",
    },
  ];

  return (
    <section className={styles.roadmap}>
      <h2 className={styles.sectionTitle}>What's Next</h2>
      <p className={styles.subtitle}>The Evolution of Pixel Moon</p>

      <div className={styles.roadmapContainer}>
        {roadmapItems.map((item, idx) => (
          <div key={idx} className={styles.roadmapItem}>
            <div className={styles.phaseLabel}>{item.phase}</div>
            <h3 className={styles.itemTitle}>{item.title}</h3>
            <p className={styles.itemDescription}>{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
